module.exports = __webpack_public_path__ + "static/img/shoes.6a5d0264.png";